import React from "react";
import styles from "./page-not-found.module.scss";

const PageNotFound = (): React.JSX.Element => (
  <div className={styles.container}>
    <h1 className={styles.title}>404</h1>
    <p className={styles.message}>Page Not Found</p>
  </div>
);

export default PageNotFound;
